module.exports = __webpack_public_path__ + "static/media/photo_007.e6239443.JPG";